/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();
const CustomerUpdate = {
	init: function() {
		$('.woocommerce-account .customer .button-primary').on('click', function() {
			setTimeout(function() {
				CustomerUpdate.updateCustomerSession();
			}, 1000);
		});

		/** Removing "Are you sure to leave the page" popup */
		if (window.acf) {
			window.acf.unload.active = false;
		}
	},
	updateCustomerSession: () => {
		const data = {
			action: 'use-customer',
			updateSession: 1
		};
		$.ajax({
			url: kadraGlobal.ajax,
			type: 'GET',
			data: data,
			success: function() {
			},
			error: function() {
			}
		});
	},
};
export default CustomerUpdate;
